/**
 * @author：
 * @update：
 * @description：
 **/
import {
  articlesList,
  classDisable,
  articlesListAdd,
  editclesList,
  seeArticlesList,
  articlesDisable,
  articlesEnable,
  articlesDel,
  fileUp,
  fileEcho,
  articlesEdit,
  articlesAdd,
  delDisable,
  articlesEditSort,
  articlesSort,
} from "../../api/url";
import E from "wangeditor";
export default {
  data() {
    return {
      fileUp: fileUp,
      token: { Authorization: "Bearer " + sessionStorage.getItem("token") },
      fileEcho: fileEcho,

      tabs: "0",
      tableData: [], //表格数据
      tableData2: [], //表格数据
      isChange: false, //是否上下移动过

      idEdit: false, //是否是编辑
      editId: "", //编辑的id
      addCatalog: false, //编辑目录弹窗
      positionType: "0", //位置
      parentData: [], //父级分类
      parentClassValue: "", //选择的目录
      menuName: "", //目录名称
      enableVal: true, //启禁用

      seeCatalog: false, //查看文章
      seeArticleId: "", //查看的id
      seeCatalogList: [], //文章列表

      editableListBol: false, //编辑新增文章
      isEditable: false, //是否是编辑
      editableListId: "", //编辑文章的id
      catalogTitle: "", //内容标题
      catalogLink: "", //内容链接
      editor: null, //富文本
      catalogEnabled: true, //启禁用
      menuNameError: false,
    };
  },
  // 自定义方法
  methods: {
    sortBtn() {
      let data = this.tableData;
      this.$ajax.post(articlesEditSort, data).then(
        (res) => {
          console.log(res);
          this.dataList(this.tabs);
          this.isChange = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
    //url验证
    urlInspect(value) {
      if (value != "") {
        let reg = /(http|https):\/\/([\w.]+\/?)\S*/;
        if (!reg.test(value)) {
          this.$message({
            showClose: true,
            message: "您输入的网址不正确,必须以http,https开头,且需符合URL规范",
            type: "error",
            center: true,
            duration: 3000,
          });
          return false;
        } else {
          return true;
        }
      }
    },
    dataList(type) {
      if (type == 0) {
        this.$ajax.get(articlesList, { pageSize: 9999 }).then(
          (res) => {
            console.log(res);
            this.tableData = res.data.rows;
            let arr = [];
            for (let i = 0; i < res.data.rows.length; i++) {
              let obj = {};
              obj.label = res.data.rows[i].name;
              obj.value = res.data.rows[i].id;
              if (
                res.data.rows[i].children.length != 0 &&
                res.data.rows[i].children != undefined
              ) {
                let arr2 = [];
                for (let j = 0; j < res.data.rows[i].children.length; j++) {
                  let obj2 = {};
                  obj2.label = res.data.rows[i].children[j].name;
                  obj2.value = res.data.rows[i].children[j].id;
                  arr2.push(obj2);
                }
                obj.children = arr2;
              }
              arr.push(obj);
            }
            this.parentData = arr;
          },
          (err) => {
            console.log(err);
            this.$message({
              showClose: true,
              message: err.data,
              type: "error",
              center: true,
              duration: 3000,
            });
          }
        );
      } else {
      }
    },
    //分类启禁用
    dataListDisable(id, type, name) {
      let data = {
        id: id,
        enabled: !type,
        name,
      };
      this.$ajax.put(classDisable(id), data).then(
        (res) => {
          console.log(res);
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
            center: true,
            duration: 3000,
          });
          this.dataList(this.tabs);
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
    //新建分类
    addList() {
      if (!this.menuName || this.menuName.trim() === "") {
        this.menuNameError = true;
        return;
      }
      this.menuNameError = false;
      if (this.positionType == "0") {
        let data = {
          name: this.menuName,
          enabled: this.enableVal,
          parentId: "",
        };
        if (this.parentClassValue != "") {
          data.parentId = this.parentClassValue[
            this.parentClassValue.length - 1
          ];
        }
        if (this.idEdit) {
          //编辑
          data.id = this.editId;
          this.$ajax.put(editclesList(this.editId), data).then(
            (res) => {
              console.log(res);
              this.dataList(this.tabs);
              this.addCatalog = false; //编辑目录弹窗
            },
            (err) => {
              console.log(err);
              this.$message({
                showClose: true,
                message: err.data,
                type: "error",
                center: true,
                duration: 3000,
              });
            }
          );
        } else {
          //新建
          this.$ajax.post(articlesListAdd, data).then(
            (res) => {
              console.log(res);
              this.dataList(this.tabs);
              this.addCatalog = false; //编辑目录弹窗
            },
            (err) => {
              console.log(err);
              this.$message({
                showClose: true,
                message: err.data,
                type: "error",
                center: true,
                duration: 3000,
              });
            }
          );
        }
      }
    },
    //关闭新建分类
    closeList() {
      this.addCatalog = false; //编辑目录弹窗
      this.positionType = "0"; //位置
      this.parentClassValue = ""; //选择的目录
      this.menuName = ""; //目录名称
      this.enableVal = true; //启禁用
      this.menuNameError = false;
    },
    //编辑分类
    editList(item) {
      let id = item.id;
      this.editId = id;
      this.closeList();
      this.idEdit = true;
      this.addCatalog = true; //编辑目录弹窗
      this.positionType = this.tabs; //位置
      for (let i = 0; i < this.parentData.length; i++) {
        if (id == this.parentData[i].value) {
          this.parentClassValue = [];
        } else {
          if (
            this.parentData[i].children != undefined &&
            this.parentData[i].children.length != 0
          ) {
            for (let j = 0; j < this.parentData[i].children.length; j++) {
              if (id == this.parentData[i].children[j].value) {
                this.parentClassValue = [this.parentData[i].value];
              }
            }
          }
        }
      }
      this.menuName = item.name;
      this.enableVal = item.enabled; //启禁用
    },
    //删除分类
    delList(id) {
      this.$ajax.delete(delDisable(id), { id: id }).then(
        (res) => {
          console.log(res);
          this.dataList(this.tabs);
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },

    //查看目录
    seeArticle(id) {
      this.seeArticleId = id;
      this.seeCatalog = true;
      this.$ajax.get(seeArticlesList, { categoryId: id }).then(
        (res) => {
          console.log(res);
          this.seeCatalogList = res.data.rows;
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
    //新增文章
    addableList() {
      this.editableListId = "";
      this.isEditable = false;
      this.editableListBol = true;
      this.catalogTitle = "";
      this.catalogEnabled = "";
      setTimeout(
        function() {
          this.infoWang();
        }.bind(this),
        300
      );
    },
    //编辑文章
    editableList(item) {
      this.editableListId = item.id;
      this.isEditable = true;
      this.editableListBol = true;
      this.catalogTitle = item.title;
      this.catalogEnabled = item.enabled;
      this.catalogLink = item.link;
      setTimeout(
        function() {
          this.infoWang(item.content);
        }.bind(this),
        300
      );
    },
    //编辑保存
    editableListBtn() {
      let data = {
        title: this.catalogTitle,
        content: this.editor.txt.html(),
        enabled: this.catalogEnabled,
        categoryId: this.seeArticleId,
      };
      if (this.catalogLink != "") {
        let bol = this.urlInspect(this.catalogLink);
        if (bol) {
          data.link = this.catalogLink;
        } else {
          // return false
          data.link = "";
        }
      } else {
        data.link = "";
      }
      if (this.isEditable) {
        data.id = this.editableListId;
        this.$ajax.put(articlesEdit(this.editableListId), data).then(
          (res) => {
            console.log(res);
            this.editableListBol = false;
            this.seeArticle(this.seeArticleId);
          },
          (err) => {
            console.log(err);
            this.$message({
              showClose: true,
              message: err.data,
              type: "error",
              center: true,
              duration: 3000,
            });
          }
        );
      } else {
        this.$ajax.post(articlesAdd, data).then(
          (res) => {
            console.log(res);
            this.editableListBol = false;
            this.seeArticle(this.seeArticleId);
          },
          (err) => {
            console.log(err);
            this.$message({
              showClose: true,
              message: err.data,
              type: "error",
              center: true,
              duration: 3000,
            });
          }
        );
      }
    },
    //禁用文章
    disableList(id) {
      this.$confirm("此操作将禁用该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax.put(articlesDisable(id), { id: id }).then(
            (res) => {
              console.log(res);
              this.$message({
                showClose: true,
                message: "禁用成功",
                type: "success",
                center: true,
                duration: 3000,
              });
              this.seeArticle(this.seeArticleId);
            },
            (err) => {
              console.log(err);
              this.$message({
                showClose: true,
                message: err.data,
                type: "error",
                center: true,
                duration: 3000,
              });
            }
          );
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    //启用文章
    enableList(id) {
      this.$confirm("此操作将启用该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax.put(articlesEnable(id), { id: id }).then(
            (res) => {
              console.log(res);
              this.$message({
                showClose: true,
                message: "启用成功",
                type: "success",
                center: true,
                duration: 3000,
              });
              this.seeArticle(this.seeArticleId);
            },
            (err) => {
              console.log(err);
              this.$message({
                showClose: true,
                message: err.data,
                type: "error",
                center: true,
                duration: 3000,
              });
            }
          );
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    //删除文章
    delableList(id) {
      this.$ajax.delete(articlesDel(id), { id: id }).then(
        (res) => {
          console.log(res);
          this.seeArticle(this.seeArticleId);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: "启用状态不可删除！",
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
    //富文本初始化
    infoWang(html) {
      document.getElementById("editorElem").innerHTML = "";
      this.editor = new E("#editorElem");
      this.editor.config.menus = [
        "head",
        "bold",
        "fontSize",
        "fontName",
        "italic",
        "underline",
        "strikeThrough",
        "indent",
        "lineHeight",
        "foreColor",
        "backColor",
        "link",
        "list",
        "justify",
        "quote",
        "emoticon",
        "image",
        "table",
        "code",
        "splitLine",
        "undo",
        "redo",
      ];
      this.editor.config.uploadImgServer =
        this.fileUp + "?keepActive=true&originalProxy=fullText"; //'http://192.168.0.107:8082/app/files/richTextUpload';//this.fileUp;  // 上传图片到服务器
      // this.editor.config.uploadImgShowBase64 = true;   // 使用 base64 保存图片
      this.editor.config.uploadImgAccept = ["jpg", "jpeg", "png", "gif", "bmp"];
      this.editor.config.debug = true; // 开启debug模式
      this.editor.config.uploadImgHeaders = {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      };
      // 3M
      this.editor.config.uploadImgMaxSize = 3 * 1024 * 1024;
      // 限制一次最多上传 1 张图片
      this.editor.config.uploadImgMaxLength = 1;
      // 上传文件参数
      this.editor.config.uploadFileName = "file";
      // 将 timeout 时间改为 5s
      this.editor.config.uploadImgTimeout = 15000;
      this.editor.create(); //创建实例
      this.editor.config.uploadImgHooks = {
        before: function(xhr, editor, files) {
          // 图片上传之前触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
          // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
          // return {
          //     prevent: true,
          //     msg: '放弃上传'
          // }
          // alert("前奏");
        },
        success: function(xhr, editor, result) {
          // 图片上传并返回结果，图片插入成功之后触发
          // xhr 是 XMLHttpRequst ��象，editor 是编辑器对象，result 是服务器端返回的结果
          // var url = result.data.url;
          // alert(JSON.stringify(url));
          // editor.txt.append(url);
          // alert("成功");
        },
        fail: function(xhr, editor, result) {
          // 图片上传并返回结果，但图片插入错误时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        },
        error: function(xhr, editor) {
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          // alert("错误");
        },
        // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
        // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
        customInsert: function(insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          insertImg(fileEcho + result.watermark);
          // result 必须是一个 JSON 格式字符串！！！否则报错
        },
      };

      if (html != "" && html != undefined) {
        this.editor.txt.html(html);
      }
    },
    //上移
    upItem(item) {
      let id = item.id;
      for (let i = 0; i < this.tableData.length; i++) {
        if (id == this.tableData[i].id) {
          if (i == 0) {
            return false;
          }
          const upDate = this.tableData[i - 1];
          this.tableData.splice(i - 1, 1);
          this.tableData.splice(i, 0, upDate);
          break;
        } else {
          if (this.tableData[i].children) {
            for (let j = 0; j < this.tableData[i].children.length; j++) {
              if (id == this.tableData[i].children[j].id) {
                if (j == 0) {
                  return false;
                }
                const upDate = this.tableData[i].children[j - 1];
                this.tableData[i].children.splice(j - 1, 1);
                this.tableData[i].children.splice(j, 0, upDate);
                break;
              } else {
                if (this.tableData[i].children[j].children) {
                  for (
                    let k = 0;
                    k < this.tableData[i].children[j].children.length;
                    k++
                  ) {
                    if (id == this.tableData[i].children[j].children[k].id) {
                      if (k == 0) {
                        return false;
                      }
                      const upDate = this.tableData[i].children[j].children[
                        k - 1
                      ];
                      this.tableData[i].children[j].children.splice(k - 1, 1);
                      this.tableData[i].children[j].children.splice(
                        k,
                        0,
                        upDate
                      );
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.isChange = true;
    },

    //下移
    downItem(item) {
      let id = item.id;
      for (let i = 0; i < this.tableData.length; i++) {
        if (id == this.tableData[i].id) {
          if (i == this.tableData.length - 1) {
            return false;
          }
          const downDate = this.tableData[i + 1];
          this.tableData.splice(i + 1, 1);
          this.tableData.splice(i, 0, downDate);
          break;
        } else {
          if (this.tableData[i].children) {
            for (let j = 0; j < this.tableData[i].children.length; j++) {
              if (id == this.tableData[i].children[j].id) {
                if (j == this.tableData[i].children.length - 1) {
                  return false;
                }
                const downDate = this.tableData[i].children[j + 1];
                this.tableData[i].children.splice(j + 1, 1);
                this.tableData[i].children.splice(j, 0, downDate);
                break;
              } else {
                if (this.tableData[i].children[j].children) {
                  for (
                    let k = 0;
                    k < this.tableData[i].children[j].children.length;
                    k++
                  ) {
                    if (id == this.tableData[i].children[j].children[k].id) {
                      if (
                        k ==
                        this.tableData[i].children[j].children.length - 1
                      ) {
                        return false;
                      }
                      const downDate = this.tableData[i].children[j].children[
                        k + 1
                      ];
                      this.tableData[i].children[j].children.splice(k + 1, 1);
                      this.tableData[i].children[j].children.splice(
                        k,
                        0,
                        downDate
                      );
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.isChange = true;
    },

    //删除提示
    delOpen(fun, id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          fun(id);
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    saveArticleOrder() {
      let data = this.seeCatalogList;
      this.$ajax.post(articlesEditSort, data).then(
        (res) => {
          this.$message({
            showClose: true,
            message: "保存成功",
            type: "success",
            center: true,
            duration: 3000,
          });
          this.isChange = false;
        },
        (err) => {
          this.$message({
            showClose: true,
            message: err.data,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
    moveItem(item, direction) {
      // 在 seeCatalogList 中找到当前项的索引
      const currentIndex = this.seeCatalogList.findIndex(
        (x) => x.id === item.id
      );

      if (direction === "up") {
        // 如果已经是第一项，则不能上移
        if (currentIndex === 0) {
          this.$message({
            showClose: true,
            message: "第一项不能上移",
            type: "warning",
            center: true,
            duration: 3000,
          });
          return;
        }

        // 上移：通过 query string 传递当前id和上一项的id
        this.$ajax
          .get(
            `${articlesSort}?up=${item.id}&down=${
              this.seeCatalogList[currentIndex - 1].id
            }`
          )
          .then(
            (res) => {
              // 成功后重新获取列表
              this.seeArticle(this.seeArticleId);
            },
            (err) => {
              this.$message({
                showClose: true,
                message: err.data,
                type: "error",
                center: true,
                duration: 3000,
              });
            }
          );
      } else if (direction === "down") {
        // 如果已经是最后一项，则不能下移
        if (currentIndex === this.seeCatalogList.length - 1) {
          this.$message({
            showClose: true,
            message: "最后一项不能下移",
            type: "warning",
            center: true,
            duration: 3000,
          });
          return;
        }

        // 下移：通过 query string 传递下一项的id和当前id
        this.$ajax
          .get(
            `${articlesSort}?up=${
              this.seeCatalogList[currentIndex + 1].id
            }&down=${item.id}`
          )
          .then(
            (res) => {
              // 成功后重新获取列表
              this.seeArticle(this.seeArticleId);
            },
            (err) => {
              this.$message({
                showClose: true,
                message: err.data,
                type: "error",
                center: true,
                duration: 3000,
              });
            }
          );
      }
    },
  },
  // 数据观察监听
  watch: {},
  // 计算数据
  computed: {},
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {},
  // 组件挂载完成之前
  beforeMount() {},
  // 组件挂载完成
  mounted() {
    this.dataList(0);
  },
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {},
};
